import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

// TODO: Replace this with a better way to import without default
// eslint-disable-next-line import/no-named-default
import { default as isOnPDP } from 'commons/isPDP';
const useIsPDP = () => {
  const $ = _c(2);
  const [isPDP, setIsPDP] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const checkIfPDP = () => {
        setIsPDP(isOnPDP());
      };
      checkIfPDP();
      const timesToCheck = [100, 200, 500, 1000, 2000, 5000, 10000];
      timesToCheck.forEach(time => {
        setTimeout(checkIfPDP, time);
      });
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isPDP;
};
export default useIsPDP;